<template>
  <div>
    <router-view></router-view>
    <div class="row" v-if="$route.name === 'brands-index'">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title" v-translate>Brands</h4>
              </div>
              <div class="col-md-6 text-right">
                <router-link class="btn btn-success" :to="{name: 'brands-add'}"><i class="nc-icon nc-simple-add"></i>&nbsp;<span v-translate>Add brand</span></router-link>
              </div>
            </div>
          </div>
          <paginated-table :table-data="[]" remote-url="expostat/brand/" :per-page="10"
                           default-ordering="-latest_event_start"
                           :search-fields="['title', 'name']">
            <template slot-scope="slot" slot="tableColumns">
                <el-table-column min-width="30" :label="'ID' | translate"
                                 sortable="custom" sort-by="id">
                  <template slot-scope="props">
                    <p>{{props.row.id}}</p>
                  </template>
                </el-table-column>
                <el-table-column
                                 sortable="custom" sort-by="title"
                                 :label="'Name' | translate">
                  <template slot-scope="props">
                    <p>{{props.row.title}}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="'Events count' | translate"
                  sortable="custom" sort-by="events_count"
                  class="td-number td-quantity">
                  <template slot-scope="props">
                    {{props.row.eventsCount}}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="'Latest event start' | translate"
                  sortable="custom" sort-by="latest_event_start"
                  class="td-number td-quantity">
                  <template slot-scope="props">
                    {{props.row.latestEventStart | moment("DD.MM.YYYY") || '-'}}
                  </template>
                </el-table-column>
                <el-table-column
                  class-name="action-buttons td-actions"
                  align="right"
                  :label="'Actions' | translate">
                  <template slot-scope="props">
                    <el-tooltip :content="'Edit' | translate" placement="top">
                      <router-link :to="{name: 'brands-edit', params: {id: props.row.id}}"><p-button type="success" size="sm" icon >
                        <i class="fa fa-edit"></i>
                      </p-button></router-link>
                    </el-tooltip>
                    <!--<el-tooltip :content="'Delete' | translate" placement="top">-->
                      <!--<p-button type="danger" size="sm" icon @click="(e) => handleDelete(e, props.$index, props.row)">-->
                        <!--<i class="fa fa-times"></i>-->
                      <!--</p-button>-->
                    <!--</el-tooltip>-->
                  </template>
                </el-table-column>
            </template>
          </paginated-table>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Table, TableColumn, Tooltip} from 'element-ui'
  import PaginatedTable from 'src/components/Expostat/Components/PaginatedTable'
  import swal from 'sweetalert2'

  export default {
    breadcrumb () {
      return {
        label: this.$gettext('Brands'),
        parent: {name: 'manage-root'}
      }
    },
    components: {
      PaginatedTable,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tooltip.name]: Tooltip
    },
    mounted () {
      this.$route.meta.title = this.$gettext('Brands')
    },
    name: 'brands-index',
    methods: {
      selectBrand(row) {

      }
    }
  }
</script>

<style scoped>

</style>
